import { HumanWhiteCaneIcon } from './HumanWhiteCaneIcon';

/**
 * author: Michael Irigoyen
 * id D85C481D-1B39-47A3-92D6-975E862AF70A
 * name human-white-cane
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-white-cane.svg
 * tags
 * - People / Family 
 * - Medical / Hospital 
 */
export const HumanBlindIcon = HumanWhiteCaneIcon;
export default HumanBlindIcon